import { createSlice } from "@reduxjs/toolkit";

import { getCoustomerAdderss } from "../../reduxApi/website/CoustomerAdderssrapi";

const CoustomerAddressSlice = createSlice({
  name: "CoustomerAddress",
  initialState: {
    status: "idle",
    CoustomerAddress: {
      address: [],
    },
    error: null,
  },
  reducers: {},
  extraReducers: (builder) => {
    builder
      .addCase(getCoustomerAdderss.pending, (state) => {
        state.status = "loading";
      })
      .addCase(getCoustomerAdderss.fulfilled, (state, action) => {
        state.status = "fulfilled";
        // Ensure we're setting the data properly
        state.CoustomerAddress = action.payload.data || { address: [] };
        state.error = null;
        console.log(" CoustomerAddress:", state.CoustomerAddress);
      })
      .addCase(getCoustomerAdderss.rejected, (state, action) => {
        state.status = "rejected";
        state.error = action.payload;
        state.CoustomerAddress = { address: [] };
        console.error("Error fetching addresses:", action.payload);
      });
  },
});

export default CoustomerAddressSlice.reducer;
